import { CustomEnum } from '@/class/CustomEnum'
export const CURRENCY_GROUP = {
  USD: {
    value: 'USD',
    label: 'USD',
    type: 'fiat',
    sign: '$',
    i18n: 'currency.usd',
    i18nUnit: 'currency.usdUnit',
  },
  KRW: {
    value: 'KRW',
    label: 'KRW',
    type: 'fiat',
    sign: '￦',
    i18n: 'currency.krw',
    i18nUnit: 'currency.krwUnit',
  },
  SGD: {
    value: 'SGD',
    label: 'SGD',
    type: 'fiat',
    sign: 'S$',
    i18n: 'currency.sgd',
    i18nUnit: 'currency.sgdUnit',
  },
  JPY: {
    value: 'JPY',
    label: 'JPY',
    type: 'fiat',
    sign: '¥',
    i18n: 'currency.jpy',
    i18nUnit: 'currency.jpyUnit',
  },
  TWD: {
    value: 'TWD',
    label: 'TWD',
    type: 'fiat',
    sign: 'NT$',
    i18n: 'currency.twd',
    i18nUnit: 'currency.twdUnit',
  },
  XRP: {
    value: 'XRP',
    label: 'XRP',
    sign: 'XRP',
    type: 'crypto',
    i18n: '',
    i18nUnit: 'currency.xrpUnit',
  },
  USDT: {
    value: 'USDT',
    label: 'USDT',
    sign: 'USDT',
    type: 'crypto',
    i18n: 'currency.usdt',
    i18nUnit: 'currency.usdtUnit',
  },
  default: {
    value: '',
    type: '',
    sign: '',
    i18n: '',
    i18nUnit: '',
  },
}

export const Currencies = new CustomEnum(CURRENCY_GROUP)
export type CurrencyType = keyof typeof CURRENCY_GROUP
